module.exports = __webpack_public_path__ + "static/DSC_9429-8bbf7fcdb239f8b0b3bb11c2554065a5.jpg";